import uuid from "uuid/v4";

export default class Tag {
  // constructor() {
  //   this.Guid = uuid();
  // }

  constructor(
    scannedTime: string,
    batchNo: string,
    SGTIN: string,
    gpsLat?: string,
    gpsLon?: string,
    scannedAntenna?: number
  ) {
    this.Guid = uuid();
    this.ScannedTime = scannedTime;
    this.BatchNo = batchNo;
    this.SGTIN = SGTIN;
    this.GPSLat = gpsLat;
    this.GPSLong = gpsLon;
    this.ScannedAntenna = scannedAntenna;
  }

  Guid: string;
  ScannedTime: string;
  BatchNo: string;
  SGTIN: string;
  //AnimalSGLN: string;
  GPSLat: string;
  GPSLong: string;
  ScannedAntenna: number;
}
